import { graphql } from '../graphql';

/**
 * Layer-context entry point: packs an IMAGE layer's TopoDOT project files and
 * all its images into a downloadable IPRJ zip. Returns the synthetic batch ID
 * created by the server. Mirrors `startMeshExport` in meshExport.query.ts.
 */
export const startIprjExport = graphql(`
  mutation StartIprjExport($input: StartIprjExportInput!) {
    startIprjExport(input: $input)
  }
`);
